import _ from "lodash";
import { IPolicyFunction } from "../../model";
//import { verifyLicenseByDate } from "./dateHelper";
//import API from "apis";

export interface IDatePolicyParams {
  expirationDate: string;
}

export const DatePolicy: IPolicyFunction = async (
  params: IDatePolicyParams
): Promise<boolean> => {
  // const { expirationDate } = params;
  //const response = await API.getTime();
  //const todayDate = _.get(response, "data.currentDate", "");
  //const validity = verifyLicenseByDate(expirationDate, todayDate as any);
  //return validity;

  // 👉 라이선스 정책 제거, 항상 true 반환
  return true;
};
